<template>
  <div>
    <v-card class="mx-auto mt-4" max-width="95%" elevation="2">
      <v-toolbar color="#37474F" dark>
        <v-toolbar-title>유저 상품 구매내역</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search_keyword"
          label="유저 아이디 검색"
          hide-details
          dense
          solo
          flat
          background-color="rgba(255,255,255,0.15)"
          dark
          style="max-width:200px;"
          @keyup.enter="OnClick_SearchUser"
          class="mr-2"
        ></v-text-field>
        <v-btn color="white" outlined dark small @click="OnClick_SearchUser">검색</v-btn>
        <v-btn icon class="ml-2" @click="Load_OrderList"><v-icon>mdi-refresh</v-icon></v-btn>
      </v-toolbar>

      <div style="overflow-x: auto;">
        <v-data-table
          :footer-props="{'items-per-page-options': [20, 50, -1]}"
          :headers="headers"
          :items="order_list"
          :loading="loadingData"
        >
          <template v-slot:item="row">
            <tr>
              <td><span :style="{ fontWeight: '900' }">{{ row.item.PID }}</span></td>
              <td>
                <span :style="{ fontWeight: '900' }">
                  {{ row.item.NICK ? row.item.NICK + ' (' + row.item.USER_ID + ')' : row.item.USER_ID }}
                </span>
              </td>
              <td>{{ row.item.PRD_NM || row.item.PRODUCT_NAME || '-' }}</td>
              <td>{{ formatCoin(row.item.PRICE || row.item.AMOUNT || 0) }} 원</td>
              <td>{{ row.item.CREATE_DT }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <div class="py-12"/>
  </div>
</template>

<script>
import { pnt_factory_user_buy_products } from '../../api/pnt_factory';

export default {
  name: 'PntFactoryGameUserBuyProducts',
  data: () => ({
    loadingData: false,
    search_keyword: '',
    order_list: [],
    headers: [
      { text: '주문번호', value: 'PID' },
      { text: '유저', value: 'USER_ID' },
      { text: '상품명', value: 'PRD_NM' },
      { text: '금액', value: 'PRICE' },
      { text: '구매일', value: 'CREATE_DT' },
    ],
  }),
  created() {
    this.Load_OrderList();
  },
  methods: {
    async Load_OrderList() {
      this.loadingData = true;
      try {
        const body = await pnt_factory_user_buy_products.get_user_buy_products({ count: 200 });
        this.order_list = body?.result_data || body?.list || body?.data?.result_data || [];
      } catch (e) {
        console.error('[PntFactory UserBuyProducts] get_user_buy_products', e);
      } finally {
        this.loadingData = false;
      }
    },
    async OnClick_SearchUser() {
      if (!this.search_keyword.trim()) { this.Load_OrderList(); return; }
      this.loadingData = true;
      try {
        const body = await pnt_factory_user_buy_products.search_user_buy_products({ user_id: this.search_keyword });
        this.order_list = body?.result_data || body?.list || [];
      } catch (e) {
        console.error('[PntFactory UserBuyProducts] search', e);
      } finally {
        this.loadingData = false;
      }
    },
    formatCoin(v) {
      const n = Number(v);
      return Number.isNaN(n) ? '0' : n.toLocaleString();
    },
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .v-data-table { overflow-x: auto; }
}
</style>
